import { generateSkinDefaults } from '@wix/editor-elements-panel';

import type { SiteAssetsSkinParams } from '../TextEffectsShared/TextEffectsShared.skinParams';
import { textEffectsSharedSkin } from '../TextEffectsShared/TextEffectsShared.skinParams';

export const textEffectsShookSkin = {
  ...textEffectsSharedSkin,
  'text-effects-color-1': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'text-effects-color-2': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'text-effects-color-3': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'text-effects-color-4': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'text-effects-color-5': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'text-effects-outline-color': {
    type: 'COLOR',
    defaultValue: '#000000',
  },
  'bevel-angle': {
    type: 'ANGLE',
    defaultValue: '0deg',
  },
  'layer-count': {
    type: 'ALPHA',
    defaultValue: '4',
  },
  'layer-spacing': {
    type: 'ALPHA',
    defaultValue: '10',
  },
  'outline-thickness': {
    type: 'ALPHA',
    defaultValue: '1',
  },
} as const satisfies SiteAssetsSkinParams;

const textEffectsShookSkinDefinitionMap: Record<string, SiteAssetsSkinParams> =
  {
    'wixui.skins.TextEffectsShook': textEffectsShookSkin,
  };

export default generateSkinDefaults(textEffectsShookSkinDefinitionMap);
